import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import blogData from "../constants/index";
import { useEffect, useState } from "react";
import { Grid, Button } from "@mui/material";
import { FaArrowRightLong } from "react-icons/fa6";
import LogoMarquee from "../component/LogoMarquee";
import aboutbackgroundText from "../assets/images/aboutbackgroundText.webp";

export default function Blogs() {
	const [title, setTitle] = useState("Blog - The BroadCast Store");
	const [description, setDescription] = useState(
		"Broadcast Store is a professional audiovisual equipment company providing services like consignment, system integration, and media migration etc.",
	);

	useEffect(() => {
		document.title = title;
		document
			.getElementById("meta-description")
			.setAttribute("content", description);

		AOS.init({ duration: 2000 });
		window.scrollTo(0, 0);
	}, [title, description]);

	return (
		<Grid>
			{/* Banner */}
			<div className="innerban">
				<div className="contact-bannerText">
					<img
						src={aboutbackgroundText}
						alt="banner text"
						className="product-bannerText-Img"
					/>
					<h1
						className="contact-heading"
						data-aos="fade-up">
						Blogs
					</h1>
				</div>
			</div>

			{/* Blog Grid Section */}
			<section
				className="blog-grid-section"
				style={{ padding: "50px 20px" }}>
				<Grid
					container
					spacing={4}
					justifyContent="center"
					data-aos="fade-up">
					{blogData.map((blog) => (
						<Grid
							item
							key={blog.id}
							xs={12}
							sm={6}
							md={4}>
							<div
								className="blog-card"
								style={{
									border: "1px solid #ddd",
									borderRadius: "10px",
									overflow: "hidden",
									background: "#fff",
									boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
									display: "flex",
									flexDirection: "column",
									height: "100%",
								}}>
								<img
									src={blog.image}
									alt={blog.title}
									style={{ width: "100%", height: "300px", objectFit: "cover" }}
								/>
								<div style={{ padding: "20px", flex: "1" }}>
									<h3 style={{ fontSize: "1.2rem", marginBottom: "10px" }}>
										{blog.title}
									</h3>
									<p
										style={{
											fontSize: "0.95rem",
											color: "#555",
											marginBottom: "15px",
										}}>
										{blog.content}
									</p>
									<Button
										variant="text"
										component={Link}
										to={`/blogs/${blog.id}`}
										endIcon={<FaArrowRightLong />}
										style={{ textTransform: "none", color: "#1976d2" }}>
										Read More
									</Button>
								</div>
							</div>
						</Grid>
					))}
				</Grid>
			</section>

			{/* Logo Section */}
			<LogoMarquee />
		</Grid>
	);
}
